/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { PutPaymentRequestsBankAccountRequestTransferFeeCondition } from './put-payment-requests-bank-account-request-transfer-fee-condition';

/**
 * 
 * @export
 * @interface PutPaymentRequestsBankAccountRequest
 */
export interface PutPaymentRequestsBankAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'bankNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'branchNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'branchName': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'accountType': PutPaymentRequestsBankAccountRequestAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'companyCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'companyName': string;
    /**
     * 
     * @type {PutPaymentRequestsBankAccountRequestTransferFeeCondition}
     * @memberof PutPaymentRequestsBankAccountRequest
     */
    'transferFeeCondition': PutPaymentRequestsBankAccountRequestTransferFeeCondition;
}

export const PutPaymentRequestsBankAccountRequestAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    other: 'OTHER'
} as const;

export type PutPaymentRequestsBankAccountRequestAccountTypeEnum = typeof PutPaymentRequestsBankAccountRequestAccountTypeEnum[keyof typeof PutPaymentRequestsBankAccountRequestAccountTypeEnum];


